/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IPatientCondition } from 'app/shared/model/patient-condition.model';
import { IICD10Diagnosis } from 'app/shared/model/icd-10-diagnosis.model';

export interface ITumor {
  id?: string;
  incidentDate?: number;
  createdBy?: string | null;
  createDate?: number;
  lastUpdated?: number;
  lastModifiedBy?: string;
  active?: boolean;
  cursor?: number;
  microSec?: number;
  timestampEntry?: number;
  notes?: string | null;
  topography?: IClinicalDictionary | null;
  morphology?: IClinicalDictionary | null;
  behaviour?: IClinicalDictionary | null;
  basisOfDiagnosis?: IClinicalDictionary | null;
  icccCode?: IClinicalDictionary | null;
  condition?: IPatientCondition | null;
  diagnosis?: IICD10Diagnosis | null;
  grade?: IClinicalDictionary | null;
  tumorStatus?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<ITumor> = {
  active: false,
};
